import React from "react";
import { cx } from "../utils";

const CcRadioCard = ({
  selected = false,
  icon,
  title,
  description,
  variant = "default",
  className,
  ...props
}) => (
  <button
    className={cx(
      "cc-radio-card",
      variant === "solid" && "cc-radio-card--solid",
      selected && "is-selected",
      className,
    )}
    type="button"
    {...props}
  >
    <span className="cc-radio-card__check" aria-hidden="true">
      {selected ? null : icon}
    </span>
    <span>
      <span className="cc-card-title">{title}</span>
      {description ? <span className="cc-body-sm">{description}</span> : null}
    </span>
  </button>
);

export default CcRadioCard;
